// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
/*
Example of calling the component from 'closeManageBusinessDayPresenter.jsx':

...
import EndpointsTestingComponent from './endpointsTestingComponent'
...

    <EndpointsTestingComponent
        closeManageBusinessDay={closeManageBusinessDay}
        onCloseManageBusinessDayPost={onCloseManageBusinessDayPost}
        onCloseManageBusinessDayClear={onCloseManageBusinessDayClear}
        {...props}
    />

*/
    export default
        function EndpointsTestingComponent(
        {
            closeManageBusinessDay, // fetch result of '/Proxy/CloseManageBusinessDay',
            // //------------------------------------------
            onCloseManageBusinessDayPost, // fetch '/Proxy/CloseManageBusinessDay',
            // //------------------------------------------
            onCloseManageBusinessDayClear,
            // //------------------------------------------
            ...props
        }
        )
        {
            const [authTokencloseManageBusinessDay, setAuthTokencloseManageBusinessDay] = React.useState('')
            const [phoneNumbercloseManageBusinessDay, setPhoneNumbercloseManageBusinessDay] = React.useState('')
            const [merchantTerminalIDcloseManageBusinessDay, setMerchantTerminalIDcloseManageBusinessDay] = React.useState('')
            React.useEffect(() => {
                const str =
                    closeManageBusinessDay === null || closeManageBusinessDay === undefined
                    ? ""
                    : JSON.stringify(closeManageBusinessDay, undefined, 2);

                document.getElementById("closeManageBusinessDayJsonId").innerHTML = str;
            }, [closeManageBusinessDay])
            function listReferenceRender() {
                return (
                    <div className='container-lg'>
                        <a
                            href='current#'
                            onClick={(event) => {
                                event.preventDefault();
                                props.history.push('/endpoint-testing-list');
                            }}
                        >
                            testing components list
                        </a>
                    </div>
                )
            }
            function proxyCloseManageBusinessDayCloseManageBusinessDayTestingForm() {
                return (
                    <>
                        <hr/>
                        <hr/>
                        <fieldset className='container-lg'>
                            <legend>Input values for endpoint '<span style={{color: 'blue'}}>/api/Proxy/CloseManageBusinessDay'</span></legend>
                            <p><span><b>Закрытие смены</b></span></p>
                            <p><span><b>Server call</b></span></p>
                            <form className='form-group' onReset={()=>onCloseManageBusinessDayClear()} onSubmit={event => {
                                event.preventDefault()
                                if (!authTokencloseManageBusinessDay) {
                                    alert("'AuthToken' is required.")
                                    return
                                }
                                if (!phoneNumbercloseManageBusinessDay) {
                                    alert("'PhoneNumber' is required.")
                                    return
                                }
                                if (!merchantTerminalIDcloseManageBusinessDay) {
                                    alert("'MerchantTerminalID' is required.")
                                    return
                                }
                                onCloseManageBusinessDayPost({authToken: authTokencloseManageBusinessDay, phoneNumber: phoneNumbercloseManageBusinessDay, merchantTerminalID: merchantTerminalIDcloseManageBusinessDay})
                            }}>
                            <div style={{marginTop: 8}} className='card'>
                                <div className='card-body'>
                                    <p style={{marginTop: 10}}><b>Body object properties (InputView properties):</b></p>
                                        <div style={{marginTop: 16}}>
                                            <div  style={{marginTop: 0}}>
                                                <label htmlFor='authTokencloseManageBusinessDayId' className='form-label'>AuthToken</label>
                                                <input type='text' id='authTokencloseManageBusinessDayId' className='form-control' value={authTokencloseManageBusinessDay} onChange={event => setAuthTokencloseManageBusinessDay(event.target.value)}/>
                                                {!authTokencloseManageBusinessDay && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'AuthToken' is required.
                                                    </div>
                                                )}
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='phoneNumbercloseManageBusinessDayId' className='form-label'>PhoneNumber</label>
                                                <input type='text' id='phoneNumbercloseManageBusinessDayId' className='form-control' value={phoneNumbercloseManageBusinessDay} onChange={event => setPhoneNumbercloseManageBusinessDay(event.target.value)}/>
                                                {!phoneNumbercloseManageBusinessDay && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'PhoneNumber' is required.
                                                    </div>
                                                )}
                                            </div>

                                            <div  style={{marginTop: 16}}>
                                                <label htmlFor='merchantTerminalIDcloseManageBusinessDayId' className='form-label'>MerchantTerminalID</label>
                                                <input type='text' id='merchantTerminalIDcloseManageBusinessDayId' className='form-control' value={merchantTerminalIDcloseManageBusinessDay} onChange={event => setMerchantTerminalIDcloseManageBusinessDay(event.target.value)}/>
                                                {!merchantTerminalIDcloseManageBusinessDay && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'MerchantTerminalID' is required.
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    <input className='btn btn-primary' style={{marginTop: 24}} type = 'submit' value = 'Submit'/>
                                    <input className='btn' style={{marginTop: 24, marginLeft: 16}} type = 'reset' value = 'Clear'/>
                                </div>
                            </div>
                            </form>
                        </fieldset>
                        {proxyCloseManageBusinessDayCloseManageBusinessDayTestingResult()}
                    </>
                )
            }
            function proxyCloseManageBusinessDayCloseManageBusinessDayTestingResult() {
                return (
                    <>
                        <div style={{marginTop: 32}} className='container-lg'>
                            <p><b>Result of endpoint '<span style={{color: 'navy'}}>/api/Proxy/CloseManageBusinessDay</span>':</b></p>
                            <span>{'--> HttpResultDto closeManageBusinessDay'}</span>
                            <pre id="closeManageBusinessDayJsonId"></pre>
                        </div>
                    </>
                )
            }
            return (
                <>
                    {listReferenceRender()}
                    {proxyCloseManageBusinessDayCloseManageBusinessDayTestingForm()}
                </>
            )
        }
